import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import Logo from './Logo';
import { CheckCircle, XCircle, Loader } from 'lucide-react';

const AuthConfirm = () => {
  const [status, setStatus] = useState('confirming'); // confirming, success, error
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        // Get the token from URL
        const params = new URLSearchParams(window.location.search);
        const tokenHash = params.get('token_hash');
        const type = params.get('type');

        if (!tokenHash) {
          setStatus('error');
          return;
        }

        // Verify the email
        const { error } = await supabase.auth.verifyOtp({
          token_hash: tokenHash,
          type: type || 'signup',
        });

        if (error) {
          console.error('Confirmation error:', error);
          setStatus('error');
        } else {
          setStatus('success');
          
          // Countdown and redirect
          let count = 3;
          const timer = setInterval(() => {
            count--;
            setCountdown(count);
            if (count === 0) {
              clearInterval(timer);
              // Try to close the tab first
              window.close();
              // If that doesn't work (cross-origin), redirect
              setTimeout(() => {
                window.location.href = '/';
              }, 100);
            }
          }, 1000);
        }
      } catch (error) {
        console.error('Confirmation error:', error);
        setStatus('error');
      }
    };

    confirmEmail();
  }, []);
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <Logo size="default" variant="gradient" />
        </div>

        {status === 'confirming' && (
          <>
            <Loader className="w-16 h-16 text-purple-600 mx-auto mb-4 animate-spin" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Confirming your email...
            </h2>
            <p className="text-gray-600">Please wait a moment</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Email Confirmed! 🎉
            </h2>
            <p className="text-gray-600 mb-4">
              Your account is ready to use.
            </p>
            <p className="text-sm text-gray-500">
              Redirecting in {countdown}... or{' '}
              <button
                onClick={() => window.location.href = '/'}
                className="text-purple-600 underline"
              >
                click here
              </button>
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-600 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Confirmation Failed
            </h2>
            <p className="text-gray-600 mb-4">
              The confirmation link may have expired or is invalid.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="bg-purple-600 hover:bg-purple-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
            >
              Go to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthConfirm;